import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import SparkMD5 from "spark-md5";

// Warn if env variables are missing
const requiredEnv = [
  "REACT_APP_S3_REGION",
  "REACT_APP_S3_ACCESS_KEY",
  "REACT_APP_S3_SECRET_KEY",
  "REACT_APP_S3_BUCKET_NAME",
];

requiredEnv.forEach((key) => {
  if (!process.env[key]) {
    console.warn(`Missing environment variable: ${key}`);
  }
});

// S3 client with virtual-hosted–style URL support
const s3Client = new S3Client({
  region: process.env.REACT_APP_S3_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
  },
  forcePathStyle: false, // Use virtual-hosted–style URLs
});

// Convert hex MD5 to base64
function hexToBase64(hex) {
  const binaryString = hex
    .match(/.{2}/g)
    .map((byte) => String.fromCharCode(parseInt(byte, 16)))
    .join("");
  return window.btoa(binaryString);
}

// Function to handle file uploads
export const uploadToS3 = async (file) => {
  try {
    if (!file) throw new Error("No file provided");

    const arrayBuffer = await file.arrayBuffer();


    const md5Hash = SparkMD5.ArrayBuffer.hash(arrayBuffer);
    const contentMd5 = hexToBase64(md5Hash);

    const key = `${Date.now()}_${file.name}`;
    const body = new Uint8Array(arrayBuffer);

    const command = new PutObjectCommand({
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Key: key,
      Body: body,
      ContentType: file.type,
      ContentMD5: contentMd5,
    });

    await s3Client.send(command);

    const fileUrl = `https://${process.env.REACT_APP_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_S3_REGION}.amazonaws.com/${key}`;

    return { data: { url: fileUrl } };
  } catch (error) {
    console.error("Error uploading to S3:", error);
    return {
      error: error.message || "An unknown error occurred during upload",
    };
  }
};
